import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import IconButton from "@react/shared/ui/IconButton"
import { useQuoteEditor } from "../context/QuoteEditorContext"

const modifier = () =>
  (typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "")) ? "⌘" : "Ctrl+"

const HistoryButtons = () => {
  const { state, dispatch } = useQuoteEditor()
  const canUndo = state.past.length > 0
  const canRedo = state.future.length > 0
  const mod     = modifier()

  return (
    <div className="flex items-center gap-0.5 pl-1 ml-1 border-l border-slate-200">
      <IconButton
        size      = "sm"
        disabled  = {!canUndo}
        onClick   = {() => dispatch({ type: "UNDO" })}
        title     = {`${I18n.t("quotes.builder.history.undo")} (${mod}Z)`}
        aria-label= {I18n.t("quotes.builder.history.undo")}
        className = {canUndo ? "" : "opacity-30 cursor-default"}
      >
        <FontAwesomeIcon icon="rotate-left" />
      </IconButton>
      <IconButton
        size      = "sm"
        disabled  = {!canRedo}
        onClick   = {() => dispatch({ type: "REDO" })}
        title     = {`${I18n.t("quotes.builder.history.redo")} (${mod}⇧Z)`}
        aria-label= {I18n.t("quotes.builder.history.redo")}
        className = {canRedo ? "" : "opacity-30 cursor-default"}
      >
        <FontAwesomeIcon icon="rotate-right" />
      </IconButton>
    </div>
  )
}

export default HistoryButtons
